import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import Legacy from './Legacy';

export default function LegacyWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper
      alias="isDisabled"
      Component={Legacy}
      {...props}
    />
  );
}
